import { IppicaTableRowInfoRenderer } from './ippicaTableRowInfoRenderer/IppicaTableRowInfoRenderer';
import { IppicaTableRowMainInfo } from './ippicaTableRowMainInfo';
import { IppicaTableRowPosition } from './ippicaTableRowPosition';
import styles from './IppicaTableRow.module.scss';
import useWindowSize from 'hooks/useWindowSize';

export type IppicaTableRowProps = {
  keyAvvenimento: string;
};

export const IppicaTableRow = ({ keyAvvenimento }: IppicaTableRowProps) => {
  const { isMobile } = useWindowSize();

  return (
    <div className={styles.container}>
      <IppicaTableRowPosition keyAvvenimento={keyAvvenimento} containerClassName={styles.position} />
      <IppicaTableRowMainInfo
        // streamingUrl={streamingUrl}
        keyAvvenimento={keyAvvenimento}
        containerClassName={styles.mainInfo}
      />
      {!isMobile && <IppicaTableRowInfoRenderer keyAvvenimento={keyAvvenimento} />}
    </div>
  );
};
